export function getShellBaseUrl(): URL {
  return new URL(__webpack_public_path__, window.location.origin);
}

export function getShellBasePath(): string {
  return getShellBaseUrl().pathname;
}

export default {};
